/**
 * Enumération des types/modes de paiement
 * Utilisé pour savoir quel type d'opération est souhaité dans le scénario
 */
export const ActionEnum = {
  banking: -1,
  debit: -2,
  credit: -3,
  reset: -4,
  giftCredit: -5,
  //
  badgeInformations: 0,
  commandeInformations: 2,
  clientInformations: -100,
  addClientCard: -200,
  // Cadeaux
  // giftChequeDebit: 1,
  // giftChequeCredit: 2,
  // giftCardDebit: 3,
  // giftCardCredit: 4,
  gift: 5,
  giftReset: 6,
  // Divers
  loyalty: 10,
  // Cashless
  cashlessReset: 20,
  cashlessDebit: 21,
  cashlessCredit: 22,
  cashlessTransfert: 23,
  // Offline
  cancelActivationOffline: 30,
  cancelDebitOffline: 31,
  cancelCreditOffline: 32,
  cashlessRefill: 33,
  // LyfPay
  lyfpayDebit: 40,
  lyfpayCredit: 41,
  //
  mobil: 50,
  restoFlash: 55,
  vivaWallet: 60,
  dpa: 65,
  invoicePayement: 66,
  voucher: 67
}

export const CategoryEnum = {
  cashless: 0,
  gift: 1,
  loyalty: 2,
  lyfpay: 3,
  banking: 4,
  giftCredit: 5
}

export const ServerEnum = {
  typePorteMonnaieCashless: 4,
  typePorteMonnaieCheque: 8,
  typePorteMonnaieCarte: 9,
  //
  typeTransactionDebit: 1,
  typeTransactionCredit: 2,
  typeTransactionActivation: 6,
  //
  typeCarteFidelite: 1,
  typeCarteChequier: 2,
  typeCarteCadeau: 3,
  typeCartePme: 4,
  typeCarteBonAchat: 5,
  typeCarteMixte: 6,
  typeCarteMixtePointex: 7,
  typeCarteBonPlan: 8,
  typeCartePmeMultiComptes: 9,
  typeCarteIdentifiantWifi: 10,
  typeCarteMixteMultiPme: 11,
  typeCarteSupportLifPay: 12,
  typeCarteAchatMarketPlace: 13,
  //
  mailActif: 1,
  mailValide: 2
}

export const ServerSessionUnknown = 'Session inconnue'

export const LanguageEnum = [
  { text: 'Français - FR', value: 'fr-FR' },
  { text: 'English - EN', value: 'en-EN' }
]

export var TypeScanEnum = [
  { text: 'enums.type_scan.nfc', icon: 'mdi-nfc', view: 'scan-nfc', show: true },
  { text: 'enums.type_scan.qr', icon: 'mdi-qrcode', view: 'scan-qrcode', show: true },
  { text: 'enums.type_scan.manual', icon: 'mdi-keyboard', view: 'scan-keyboard', show: true },
  { text: 'enums.type_scan.swipe', icon: 'mdi-credit-card', view: 'scan-swipe', show: false },
  { text: 'enums.type_scan.qr_usb', icon: 'mdi-qrcode', view: 'scan-qrcode-usb', show: false }
]

export var OrientationEnum = [
  { text: 'enums.orientation.portrait', value: 'portrait-primary' },
  { text: 'enums.orientation.landscape', value: 'landscape-primary' },
  { text: 'enums.orientation.invert_portrait', value: 'portrait-secondary' },
  { text: 'enums.orientation.invert_landscape', value: 'landscape-secondary' }
]

/**
 * Enumération des mode de règlement
 * Crédit cashless
 */
export const CreditEnum = [
  { name: 'cashless_reload_modes.cb', mode: '1' },
  { name: 'cashless_reload_modes.amex', mode: '2' },
  { name: 'cashless_reload_modes.cetelem', mode: '3' },
  { name: 'cashless_reload_modes.virement', mode: '5' },
  { name: 'cashless_reload_modes.niners', mode: '6' },
  { name: 'cashless_reload_modes.franfinance', mode: '8' },
  { name: 'cashless_reload_modes.jcb', mode: '9' },
  { name: 'cashless_reload_modes.cheque', mode: 'C' },
  { name: 'cashless_reload_modes.accord_finance', mode: 'A' },
  { name: 'cashless_reload_modes.offert', mode: 'O' },
  { name: 'cashless_reload_modes.cup', mode: 'U' },
  { name: 'cashless_reload_modes.fintrax', mode: 'F' },
  { name: 'cashless_reload_modes.autres', mode: '0' },
  { name: 'cashless_reload_modes.especes', mode: 'E' },
  { name: 'cashless_reload_modes.pme', mode: 'P' },
  { name: 'cashless_reload_modes.token', mode: 'T' },
  { name: 'cashless_reload_modes.gestion', mode: 'G' },
  { name: 'cashless_reload_modes.ecocup', mode: 'W' },
  { name: 'cashless_reload_modes.catering', mode: 'R' },
  { name: 'cashless_reload_modes.lyfpay', mode: 'L' },
  { name: 'cashless_reload_modes.payweb', mode: 'B' },
  { name: 'cashless_reload_modes.transfert', mode: 'X' },
  { name: 'cashless_reload_modes.lydia', mode: 'Y' },
]
export const MODE = {
  CB: '1',
  Amex: '2',
  Cetelem: '3',
  Virement: '5',
  Diners: '6',
  Franfinance: '8',
  JCB: '9',
  Cheque: 'C',
  AccordFinance: 'A',
  Offert: 'O',
  CUP: 'U',
  Fintrax: 'F',
  Autres: '0',
  Especes: 'E',
  PME: 'P',
  Token: 'T',
  Gestion: 'G',
  Ecocup: 'W',
  Catering: 'R',
  Lyfpay: 'L',
  CB_PayWeb: 'B',
  Transfert_Online_Offline: 'X',
  Lydia: 'Y'
}

/**
 * Structure Lyfpay si échec initialisation plugin
 */
export const LyfpayNull = {
  Credit: 0,
  Debit: 0,
  Direct: 0,
  Integre: 0,
  IDProgram: 0,
  Token: null
}

export const DrawerFullOptions = {
  infos: 1,
  search: 1,
  duplicate: 1,
  cancel: 1,
  consult: 1,
  collect: 1
}

/**
 * Nombre maximun de transactions en attente
 * Avant messages / coupures
 */
export const LimitTransactionLight = 450
export const LimitTransactionHard = 500

/**
 * Autres limites
 */
export const MaxTryPinCode = 3

/**
 * Camera errors
 */
export const CameraErrorEnum = {
  UNEXPECTED_ERROR: 0, // An unexpected error. Returned only by bugs in QRScanner.
  CAMERA_ACCESS_DENIED: 1, // The user denied camera access.
  CAMERA_ACCESS_RESTRICTED: 2, // Camera access is restricted (due to parental controls, organization security configuration profiles, or similar reasons).
  BACK_CAMERA_UNAVAILABLE: 3, // The back camera is unavailable.
  FRONT_CAMERA_UNAVAILABLE: 4, // The front camera is unavailable.
  CAMERA_UNAVAILABLE: 5, // The camera is unavailable because it doesn't exist or is otherwise unable to be configured. (Also returned if QRScanner cannot return one of the more specific BACK_CAMERA_UNAVAILABLE or FRONT_CAMERA_UNAVAILABLE errors.)
  SCAN_CANCELED: 6, // Scan was canceled by the cancelScan() method. (Returned exclusively to the QRScanner.scan() method.)
  LIGHT_UNAVAILABLE: 7, // The device light is unavailable because it doesn't exist or is otherwise unable to be configured.
  OPEN_SETTINGS_UNAVAILABLE: 8 // The device is unable to open settings.
}

/**
 * Camera position
 */
export const CameraPositionEnum = {
  Back: 0,
  Front: 1
}

/**
 * Codes résultats bancaire PAX
 */
export const PaxResultEnum = {
  Unknown: 0,
  Success: 1,
  Refused: 2,
  Aborted: 3,
  Error: 4,
  // Complementary result
  Canceled: 31,
  Ripped: 3,
  Payment: 23
}

/**
 * Types de transactions bancaire Nepting
 */
export const NeptingPaymentEnum = [
  'Debit',
  'Refund',
  'Reversal'
]

/**
 * Types de transactions bancaire PAX
 */
export const PaymentEnum = [
  'DEBIT',
  'CREDIT',
  'CANCEL'
]

/**
 * Types de requêtes bancaire PAX
 */
export const PaxRequestEnum = [
  { title: 'button.pax.reprint_last_trs', type: 'ReprintLastTrs' },
  { title: 'button.pax.reconciliation', type: 'Reconciliation' },
  { title: 'button.pax.remote_parameterization', type: 'RemoteParameterization' }
]

/**
 * Types de rapports bancaire PAX
 */
export const PaxReportsEnum = [
  { title: 'button.pax.reconciliation_report', type: 'ReconciliationReport' },
  { title: 'button.pax.remote_parameterization_report', type: 'RemoteParameterizationReport' },
  { title: 'button.pax.reference_parameter_report', type: 'ReferenceParameterReport' },
  { title: 'button.pax.functionnal_parameter_report', type: 'FunctionnalParameterReport' },
  { title: 'button.pax.summary_report', type: 'SummaryReport' },
  { title: 'button.pax.terminal_summary_report', type: 'TerminalSummaryReport' },
  { title: 'button.pax.session_summary_report', type: 'SessionSummaryReport' },
  { title: 'button.pax.config_report', type: 'ConfigReport' }
]

export const DurationEnum = [
  { text: '10 secondes', value: 10 },
  { text: '30 secondes', value: 30 },
  { text: '1 minute', value: 60 },
  { text: '2 minutes', value: 120 },
  { text: '5 minutes', value: 300 },
  { text: '10 minutes', value: 600 },
  { text: '15 minutes', value: 900 }
]

/**
 * Couleurs
 */
export const ColorEnum = {
  cashless: '#1497C2',
  gift: '#F3B900',
  banking: 'black',
  vivawallet: '#00c8dd',
  lyfpay: 'red',
  loyalty: 'green',
  ssp: '#66c9cb',
}

export const IconEnum = {
  basket: 'mdi-basket',
  close: 'close',
  delete: 'mdi-delete',
  plus: 'mdi-plus',
  minus: 'mdi-minus',
  printer: 'mdi-printer',
  cards: 'mdi-cards',
  add_buy: 'mdi-credit-card-plus',
  add: 'mdi-plus-box',
  //
  star: 'mdi-star',
  info: 'mdi-information',
  warning: 'mdi-alert',
  refresh: 'mdi-refresh',
  reload: 'mdi-reload',
  id: 'mdi-assistant',
  //
  ch_up: 'mdi-chevron-up',
  ch_down: 'mdi-chevron-down',
  ch_left: 'mdi-chevron-left',
  ch_right: 'mdi-chevron-right',
  // ***** Text field *****
  edit: 'mdi-pencil',
  user: 'person',
  mail: 'mail',
  mobile: 'phone',
  phone: 'mdi-phone-classic',
  address: 'map',
  password: 'lock',
  shop_field: 'mdi-cellphone-android',
  licence: 'mdi-key-variant',
  rank: 'mdi-format-list-bulleted',
  envelope: 'mdi-android-messages',
  mobil_quantity: 'mdi-cart-arrow-down',
  mobil_total: 'mdi-equal',
  client_field: 'mdi-briefcase',
  date_field: 'event',
  // ***** Drawer *****
  info_badge: 'mdi-account-card-details',
  info_commande: 'mdi-account-card-details-outline',
  client_search: 'mdi-briefcase-search',
  customer: 'mdi-account',
  duplicate: 'mdi-cards-outline',
  cancellation: 'mdi-cancel',
  settings: 'settings',
  shop_choice: 'mdi-camera-switch',
  disconnection: 'mdi-power',
  close_app: 'mdi-exit-to-app',
  // ***** Toolbar *****
  wan: 'mdi-wan',
  wifi: 'mdi-wifi',
  wifi_off: 'mdi-wifi-off',
  g_2: 'mdi-signal-2g',
  g_3: 'mdi-signal-3g',
  g_4: 'mdi-signal-4g',
  // ***** keyboard *****
  keyboard: 'mdi-keyboard-variant',
  // ***** Scan *****
  scan_swipe: 'mdi-credit-card',
  scan_nfc: 'mdi-nfc',
  scan_qrcode: 'mdi-qrcode',
  scan_keyboard: 'mdi-keyboard'
}

export const MonthsAbbreviated = [
  'JANV.',
  'FÉVR.',
  'MARS',
  'AVR.',
  'MAI',
  'JUIN',
  'JUILL.',
  'AOÛT',
  'SEPT.',
  'OCT.',
  'NOV.',
  'DÉC.'
]

export const IntentAction = {
  MAIN: 'android.intent.action.MAIN',
  INIT: 'com.ciss.myterminal.INIT',
  PRINT: 'com.ciss.myterminal.PRINT',
  CASHLESS: 'com.ciss.myterminal.CASHLESS',
  SETTINGS: 'com.ciss.myterminal.SETTINGS',
  TRANSACTION: 'com.ciss.myterminal.TRANSACTION',
  CLOSING: 'com.ciss.myterminal.CLOSING'
}

export const HioposTransactionResultEnum = {
  ACCEPTED: 'ACCEPTED',
  FAILED: 'FAILED',
  UNKNOWN_RESULT: 'UNKNOWN_RESULT'
}

export const SCAN_TYPE = {
  NFC: 'NFC',
  QR_CODE: 'QR',
  SWIPE: 'Long',
  MANUAL: 'MAN'
}

export const ERRORKEY = '$2y$10$sO4CKu01R6BTzfuSKmVCH.01O7pOABl2Y2Tbz6bCCR2hgdCiymq0S'

export const TypeValeurEnum = {
  ARRONDI: 'C',
  LIBRE: 'N',
  FIXE: 'F',
  POURCENTAGE: '%'
}

export const MealVoucherEnum = [
  'CONECS',
  'SODEXO',
  'NATIXIS_INTERTITRES',
  'EDENRED',
  'CHEQUE_DEJEUNER',
  'CADHOC',
  'KADEOS',
  'MONEO_RESTO',
  'MONETICO_RESTO',
  'DIGIBON',
  'SWILE',
  'ILLICADO'
]

export const TypeCarteEnum = {
  8: 'Chèque cadeau',
  9: 'Carte cadeau'
}

export const EnumIDCfgMPCommandeStatut = {
  ERREUR: 1,
  ERREUR_CAPTURE: 1,
  PHASE_PAIEMENT: 10,
  PAIEMENT_AUTORISE: 11,
  PAIEMENT_EFFECTUE: 12,
  PAIEMENT_VALIDATION_MANUELLE: 13,
  REMBOURSEMENT_DEMANDE: 20,
  REMBOURSEMENT_ACCEPTE: 21,
  REMBOURSEE: 22,
  REMBOURSEMENT_REFUSEE: 23
}

export const EnumCommandeStatutPreparation = {
  EN_ATTENTE: 0,
  VALIDEE: 10,
  REFUSEE: 11,
  ABANDON_MARCHAND: 12,
  EN_PREPARATION: 20,
  PREPAREE: 21,
  MISE_EN_LIVRAISON: 30,
  EN_LIVRAISON: 31,
  DELIVREE: 40,
  LIVRAISON_REFUSEE: 41,
  LIVRAISON_IMPOSSIBLE: 42
}
export const EnumModeCashiers = {
  NONE: 'NONE',
  SESSION: 'SESSION',
  FLOATING: 'FLOATING'
}
